const itbModule = '.btd-module-itb';
const imageContainer = '.image-container';
const itbImage = '.text-image-button__image.image_click';
const fullscreenCls = 'fullScreen';
const closeButton = '.close';

$(itbImage, itbModule).on('click', function (event) {
    event.preventDefault();
    $(this).closest(imageContainer).addClass(fullscreenCls);

})

$(closeButton, itbModule).on('click', (event) => {
    event.preventDefault();
    $(imageContainer, itbModule).removeClass(fullscreenCls);
});

$(document).on('keyup', () => {
    $(imageContainer, itbModule).removeClass(fullscreenCls);
});


